export interface PreDraftAudienceChildLike {
  key: string | number;
  selected: boolean | null;
  metadata: { value: { completes: number | null } | null };
}

export interface PreDraftInsightsChildLike {
  feasibility: { total: number; cpi: number };
}

function selectedChildren<TChild extends { selected: boolean | null }>(
  audienceChildren: Record<string, TChild>,
): TChild[] {
  return Object.values(audienceChildren).filter((child) => child.selected);
}

export function sumPreDraftFeasibility(
  audienceChildren: Record<string, PreDraftAudienceChildLike>,
  insightsChildren: Record<string, PreDraftInsightsChildLike>,
): number {
  return selectedChildren(audienceChildren).reduce(
    (sum, child) => sum + (insightsChildren[child.key]?.feasibility.total ?? 0),
    0,
  );
}

export function averagePreDraftCpi(
  audienceChildren: Record<string, PreDraftAudienceChildLike>,
  insightsChildren: Record<string, PreDraftInsightsChildLike>,
): number {
  const selectedCpis = selectedChildren(audienceChildren).map(
    (child) => insightsChildren[child.key]?.feasibility.cpi ?? 0,
  );

  return selectedCpis.length
    ? selectedCpis.reduce((sum, cpi) => sum + cpi, 0) / selectedCpis.length
    : 0;
}

export function sumPreDraftCompletes(
  audienceChildren: Record<string, PreDraftAudienceChildLike>,
): number {
  return selectedChildren(audienceChildren).reduce(
    (sum, child) => sum + (child.metadata.value?.completes ?? 0),
    0,
  );
}
